import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { forwardRef, useId } from 'react';
import { preventDefault } from '../../utils';
import styles from './ToggleButton.module.css';
import { ToggleButtonProps } from './types';
const ToggleButton = forwardRef<HTMLInputElement, ToggleButtonProps>(function ToggleButton(t0, ref) {
  const $ = _c(30);
  let children;
  let disabled;
  let disabled_;
  let externalStyles;
  let fullWidth;
  let id_;
  let name;
  let onChange;
  let onClick;
  let props;
  let t1;
  let t2;
  let value;
  if ($[0] !== t0) {
    ({
      id: id_,
      children,
      value,
      name,
      onChange,
      onClick,
      className: externalStyles,
      type: t1,
      size: t2,
      disabled_,
      disabled,
      fullWidth,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = disabled;
    $[3] = disabled_;
    $[4] = externalStyles;
    $[5] = fullWidth;
    $[6] = id_;
    $[7] = name;
    $[8] = onChange;
    $[9] = onClick;
    $[10] = props;
    $[11] = t1;
    $[12] = t2;
    $[13] = value;
  } else {
    children = $[1];
    disabled = $[2];
    disabled_ = $[3];
    externalStyles = $[4];
    fullWidth = $[5];
    id_ = $[6];
    name = $[7];
    onChange = $[8];
    onClick = $[9];
    props = $[10];
    t1 = $[11];
    t2 = $[12];
    value = $[13];
  }
  const type = t1 === undefined ? "radio" : t1;
  const size = t2 === undefined ? "default" : t2;
  const className = classNames(styles.button, styles[`size-${size}`], externalStyles);
  const generatedId = useId();
  const id = id_ || name || generatedId;
  const composedId = `${id}-${String(value)}`;
  const isInputDisabled = disabled || disabled_;
  const t3 = classNames({
    "fullWidth": fullWidth && fullWidth !== "mobile-only",
    "fullWidthOnMobile": fullWidth && fullWidth === "mobile-only"
  }, className);
  const t4 = isInputDisabled ? preventDefault : onClick;
  const t5 = isInputDisabled ? preventDefault : onChange;
  let t6;
  if ($[14] !== composedId || $[15] !== disabled_ || $[16] !== isInputDisabled || $[17] !== name || $[18] !== props || $[19] !== ref || $[20] !== t4 || $[21] !== t5 || $[22] !== type || $[23] !== value) {
    t6 = <input {...props} ref={ref} id={composedId} aria-disabled={isInputDisabled} type={type} value={value} name={name} onClick={t4} onChange={t5} className={styles.hiddenInput} disabled={disabled_} />;
    $[14] = composedId;
    $[15] = disabled_;
    $[16] = isInputDisabled;
    $[17] = name;
    $[18] = props;
    $[19] = ref;
    $[20] = t4;
    $[21] = t5;
    $[22] = type;
    $[23] = value;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  let t7;
  if ($[25] !== children || $[26] !== composedId || $[27] !== t3 || $[28] !== t6) {
    t7 = <label htmlFor={composedId} className={t3}>{t6}{children}</label>;
    $[25] = children;
    $[26] = composedId;
    $[27] = t3;
    $[28] = t6;
    $[29] = t7;
  } else {
    t7 = $[29];
  }
  return t7;
});
export default ToggleButton;